import i18next from 'i18next';
import { StateCreator } from 'zustand';

export interface ILanguageStore {
  languages: { language: string }[];
  getLanguagesOptions: () => { label: string; value: string }[];
  setLanguages: (languages: { language: string }[]) => void;
  language: string | null;
  setLanguage: (lang: string) => void;
}

const mapLanguagesToOptions = (languages: { language: string }[]) =>
  languages.map(l => ({
    label: i18next.t(`enum.supportedLanguages.${l.language.split('-')[0]}`),
    value: l.language,
  }));

export const createLanguageSlice: StateCreator<
  ILanguageStore,
  [],
  [],
  ILanguageStore
> = (set, get) => ({
  languages: [],
  getLanguagesOptions: () => mapLanguagesToOptions(get().languages),
  setLanguages: languages => set({ languages: languages ?? [] }),

  language: localStorage.getItem('language') ?? null,
  setLanguage: lang => {
    localStorage.setItem('language', lang);
    set({ language: lang });
  },
});
